import { forwardRef } from 'react'

const GlowingButton = forwardRef(({ 
  children, 
  variant = 'primary', 
  size = 'md', 
  className = '',
  loading = false,
  ...props 
}, ref) => {
  const baseClasses = 'relative inline-flex items-center justify-center font-semibold rounded-xl transition-all duration-300 transform hover:-translate-y-1 hover:shadow-2xl focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed overflow-hidden group'
  
  const variants = {
    primary: 'bg-gradient-to-r from-pink-500 to-blue-500 text-white shadow-lg hover:shadow-pink-500/25',
    secondary: 'bg-gradient-to-r from-gray-600 to-gray-800 text-white shadow-lg hover:shadow-gray-500/25',
    accent: 'bg-gradient-to-r from-blue-500 to-purple-500 text-white shadow-lg hover:shadow-blue-500/25'
  }
  
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg'
  }
  
  const buttonClasses = `${baseClasses} ${variants[variant]} ${sizes[size]} ${className}`
  
  return (
    <button
      ref={ref}
      className={buttonClasses}
      disabled={loading}
      {...props}
    >
      <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 transform -skew-x-12 group-hover:animate-shine"></div>
      
      <span className="relative z-10 flex items-center">
        {loading && (
          <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin mr-2"></div>
        )}
        {children}
      </span>
    </button>
  )
})

GlowingButton.displayName = 'GlowingButton'

export default GlowingButton